import { TableCell, TableRow, Typography } from '@mui/material'
import { com } from '@eidu/web'
import VisualizerTableCell from './VisualizerTableCell'
import type { ColumnHeader, RowHeader } from './utils'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityWithLabelAndRelated from '../../../domain/entity/EntityWithLabelAndRelated'

type VisualizerTableRowProps = {
  row: RowHeader
  visibleColumnHeaders: readonly ColumnHeader[]
  totalColumnCount: number
  columnByKey: ReadonlyMap<string, ColumnHeader>
  entityTypes: readonly EntityType[]
  entitiesByTypeId: ReadonlyMap<EntityTypeId, ReadonlyMap<EntityId, EntityWithLabelAndRelated>>
}

const VisualizerTableRow = ({
  row,
  visibleColumnHeaders,
  totalColumnCount,
  columnByKey,
  entityTypes,
  entitiesByTypeId,
}: VisualizerTableRowProps) => {
  if (row.type === 'kind') {
    return (
      <TableRow key={row.id}>
        <TableCell
          colSpan={1 + totalColumnCount}
          sx={{
            bgcolor: 'action.selected',
            fontWeight: 600,
            borderBottom: 1,
            borderColor: 'divider',
            py: 0.5,
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {row.label}
          </Typography>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <TableRow key={row.id} hover>
      <TableCell
        sx={{
          fontWeight: 400,
          color: 'text.primary',
          pl: row.type === 'entity' ? 3 : 1,
          whiteSpace: 'nowrap',
          borderRight: 1,
          borderColor: 'divider',
          bgcolor: 'action.hover',
        }}
      >
        {row.label}
      </TableCell>
      {visibleColumnHeaders.map((column) => (
        <VisualizerTableCell
          key={`${row.id}-${column.id}`}
          row={row}
          column={column}
          columnByKey={columnByKey}
          entityTypes={entityTypes}
          entitiesByTypeId={entitiesByTypeId}
        />
      ))}
    </TableRow>
  )
}

export default VisualizerTableRow
